module.exports = __webpack_public_path__ + "img/лого_подписи.12e4e288.svg";